import React, { useEffect, useReducer, useContext } from "react";
import { Grid } from "@material-ui/core";
import { BadgeContext, AuthContext } from "../context";
import { laboratoryServices } from "../services";
// import NotificationsIcon from '@material-ui/icons/NotificationsOutlined';

export default function TopBar(props) {
  const { children } = props;
  const { authState } = useContext(AuthContext);
  // const [notifications] = useState([]);

  const [badgeState, dispatch] = useReducer(
    (prevState, action) => {
      switch (action.type) {
        case "SETQUANTITY":
          return {
            ...prevState,
            quantity: action.quantity,
          };
        default:
          return { ...prevState };
      }
    },
    {
      quantity: 0,
    }
  );

  const badgeProvider = {
    badgeState,
    setQuantity: async ({ quantity }) => {
      dispatch({ type: "SETQUANTITY", quantity });
    },
  };

  useEffect(() => {
    async function getQuantityReports() {
      if (
        authState.user &&
        (authState.user.role.name === "USER_LABORATORY" ||
          authState.user.role.name === "MASTER" ||
          authState.user.role.name === "ADMINISTRADOR")
      ) {
        const { status, response } =
          await laboratoryServices.getUnreadReportsQuantity({
            laboratoryId: authState.user.laboratory
              ? authState.user.laboratory._id
              : null,
            token: authState.token,
          });
        if (status === 200) {
          dispatch({ type: "SETQUANTITY", quantity: response.count });
        }
      }
    }
    getQuantityReports();
  }, [authState]);

  return (
    <Grid container>
      <BadgeContext.Provider value={badgeProvider}>
        <Grid container style={{ flex: 1, flexWrap: "nowrap" }}>
          {children}
        </Grid>
      </BadgeContext.Provider>
    </Grid>
  );
}
